import React from "react";
import "./PrivacyPolicyComp.css";

const PrivacyPolicyComp = () => {
  return (
    <>
      <div className="mainPrivacyPolicy">
        <div className="txtPrivacyHead">Privacy Policy</div>

        <div className="topTextPriPart">
          <p>
            TheCryptoHub Advisors, LLC<strong> (“we,” “us,” or “our”)</strong>{" "}
            respects your privacy and knows that you care about protecting your
            personal information. This privacy policy identifies what
            information we collect from you when you use cms.thecryptohub.co
            (the “**Site**,” including all subdomains) and the services made
            available through it, or by us including the TheCryptoHub email
            newsletter (the “<strong>Newsletter</strong>”) webinars or other
            virtual events that we host (collectively, the “
            <strong>Services</strong>”) and explains how we may use or share
            that information. We will only use and share your information as
            described in this privacy policy.
          </p>
          <p>
            This Site primarily operates as a for-profit business website. This
            privacy policy applies to information we collect from you on the
            Site; through the Services; in email, text, and other electronic
            correspondence; and through any mobile or desktop application
            through which we may communicate. This privacy policy does not apply
            to information we collect offline or that any third party collects
            from you after you follow links on the Site, including any
            advertising and affiliate links.
          </p>
          <p>
            PLEASE READ THIS PRIVACY POLICY AND OUR TERMS OF USE CAREFULLY. THE
            TERMS STATED IN THIS PRIVACY POLICY CONSTITUTE A BINDING LEGAL
            AGREEMENT BETWEEN YOU AND THECRYPTOHUB ADVISORS, LLC. BY USING THIS
            SITE AND THE RELATED SERVICES, YOU UNCONDITIONALLY AGREE TO BE BOUND
            BY THE TERMS STATED IN THIS PRIVACY POLICY AND OUR TERMS OF USE,
            INCLUDING ALL EXCLUSIONS AND LIMITATIONS OF LIABILITY, AND WARRANT
            THAT YOU HAVE FULL AUTHORITY AND CAPACITY, LEGAL AND OTHERWISE, TO
            USE THE SERVICES. YOU MAY NOT ACCESS OR USE THIS SITE OR THE
            SERVICES IF YOU DO NOT AGREE TO ANY PART OF THESE TERMS. WE RESERVE
            THE RIGHT TO PERIODICALLY MAKE UPDATES TO THIS PRIVACY POLICY AS OUR
            PRACTICES CHANGE. YOUR CONTINUED USE OF THE SITE AFTER SUCH CHANGES
            CONSTITUTES YOUR ACCEPTANCE OF THE CHANGES, SO PLEASE CHECK BACK
            PERIODICALLY FOR UPDATES
          </p>

          <p>
            <strong> 1. Information We Collect</strong>
          </p>
          <p>
            We may collect and use the following types of information from those
            who use the Site and the Services:
          </p>

          <p>
            – Information by which you may be personally identified, such as
            your name, address, email address, phone number, billing and credit
            card information, and other information that may not be publicly
            available (“**personal information**”).
          </p>
          <p>
            – Information about you that does not identify you personally,
            including, but not limited to, your demographic information (for
            example, your age, gender, race, religion, political affiliation,
            and household income), personal interests, online interactions,
            viewing data, requests for Services, communications with us and
            third parties, advertisement interactions, and any other activities
            when using the Site or the Services.
          </p>
          <p>
            – Information you provide when you register with the Site and the
            Services, when adding or updating account preferences, and when
            subscribing for any Services.
          </p>
          <p>
            – Information about your transactions using the Site and the
            Services, including, but not limited to, your purchases and order
            history.
          </p>
          <p>
            We may combine information you provide us with other information
            about you that we obtain from your past use of the Site and
            Services, from our business partners, and from other companies. We
            may access other information about you collected from third parties,
            such as social media and marketing companies. We will treat any
            non-personal information that is combined with personal information
            as if it were all personal information.
          </p>
          <p>1. Automatic Data Collection</p>
          <p>
            We collect the following types of information from you as you use
            the Site through automatic data collection technologies:
          </p>

          <p>
            – Log file information commonly collected by host servers when you
            visit websites, including internet protocol (IP) addresses, browser
            type, Internet Service Provider (ISP), date and time stamps,
            referring/exit pages, domain names, landing pages, pages viewed,
            click counts, and similar information. This information is not
            connected to personal information and is used for purposes of
            administering the Site, analyzing trends, tracking visitor activity,
            and collecting demographic data.
          </p>

          <p>
            – Other details regarding your activities on the Site and Services,
            including your equipment, operating system, software, traffic
            information, and location data.
          </p>
          <p>
            Our automatic data collection includes the use of the following
            technologies:
          </p>
          <p>
            <strong>Cookies. </strong>A “cookie” is a small piece of data that
            is stored on a visitor’s hard drive in order to store information
            about visitor preferences and activities on the Site. We use this
            information to optimize the experiences of our visitors. For
            instance, a cookie can help us identify you when you return to the
            Site in order to save you time. In the event that our business
            partners, affiliates, or advertisers on the Site use cookies, we
            will not have access or control over such cookies. However, any use
            of cookies will not relate to any personally identifiable
            information about you. You may also choose to refuse to accept
            cookies by configuring the appropriate setting on your browser.
            However, doing so may prevent you from being able to access parts of
            the Site or Services and may prevent the Site from functioning
            properly.
          </p>
          <p>
            <strong>Google Analytics.</strong> We may use Google Analytics or
            similar services to collect non-personal information from you
            regarding your use of the Site. Google Analytics is a web analytics
            service offered by Google, Inc. that mainly uses cookies to report
            on your interactions on the Site and analyzes how you use the Site.
            For more information on Google Analytics, including how to set up
            privacy controls on how Google Analytics collects your information,
            please see the help article, ***[Safeguarding your
            data](http://www.google.com/analytics/learn/privacy.html)***.
          </p>
          <p>1. How We Respond to Do Not Track Signals</p>

          <p>
            Because we track visitors’ activities over time and across
            third-party websites, we respond to Do Not Track (DNT) signals sent
            to us from our visitors’ browsers. However, we do not allow third
            parties to track such activities. You can opt out of behavioral
            tracking on this Site as follows: send an email to
            thecryptohub.com@gmail.com. Personally identifiable information may
            be collected from you when we receive a DNT signal from your
            browser. We use this information in order to store information about
            your preferences, improve the Site, recognize when you return to the
            Site, and offer a more personalized experience to you, which may
            include sending targeted marketing emails and communications.
          </p>
          <p>
            <strong>1. How We Use Your Information</strong>
          </p>

          <p>
            We use information collected from you or about you, including
            personal information, for the following purposes:
          </p>
          <p>– To administer the Site and enforce our rules and policies.</p>
          <p>– To provide access to Site content and Services to you.</p>
          <p>
            – To customize Site content and Services according to your
            preferences.
          </p>
          <p>– To improve the Site and Services.</p>
          <p>
            – To research and analyze the usage data, preferences, and trends of
            our visitors.
          </p>
          <p>– To diagnose technical or Service-related problems.</p>
          <p>
            – To maintain security over your information, the Site, and its
            contents.
          </p>
          <p>– To research and analyze our target demographics.</p>
          <p>
            – To fulfill any requests for information, products, or Services.
          </p>
          <p>
            – To send you marketing communications, such as information about
            new products, Services, or specials.
          </p>
          <p>– To contact you regarding Services we provide you.</p>
          <p>– To contact you regarding your account or profile.</p>
          <p>– To contact you regarding changes to this privacy policy.</p>
          <p>
            – To sell or rent your information to third parties, subject to
            applicable laws and restrictions.
          </p>
          <p>
            – To carry out our responsibilities and enforce any contracts
            between you and us, including billing and collection rights.
          </p>
          <p>
            – For any other use as we may indicate at the time you provide the
            information.
          </p>
          <p>– To fulfill any other purpose with your consent.</p>
          <p>
            All information collected from visitors of the Site belongs to us,
            whether or not such information is personal information, information
            you volunteer, or information passively collected about you. As
            such, such information may be subject to transfer to a new owner in
            the event of our bankruptcy, sale, or liquidation.
          </p>
          <p>
            <strong>2. **How We Share Your Information**</strong>
          </p>
          <p>
            We may share personal information and other information that we
            collect as follows:
          </p>
          <p>
            – With our affiliates, including any subsidiaries we now own or
            later acquire.
          </p>
          <p>
            – With our trusted employees, contractors, business partners,
            service providers, suppliers, vendors, and other third parties that
            support us, which may include sending you emails on our behalf;
            analyzing your activities and interactions on the Site in order to
            make improvements to the Site, Services, and experiences of our
            visitors; and providing support to the Site, the Services, our
            operations, or fulfilling your requests. These third parties may
            only use personal information in order to provide such support and
            are contractually required to maintain the confidentiality of your
            information. For example, we may share personal information with
            credit card processing companies in order to bill visitors for goods
            or services.
          </p>
          <p>
            – With a buyer, successor, or other third party due to a merger,
            restructuring, reorganization, or other transfer or disposition of
            TheCryptoHub Advisors, LLC or our operations, including, but not
            limited to, in the event of a sale, bankruptcy, dissolution, or
            similar proceeding. In such event, we will provide you with prior
            notification if your information will become subject to a different
            privacy policy.
          </p>
          <p>
            – In response to court orders, subpoenas, or legal processes, such
            as requests from government regulatory or law enforcement agencies;
            to defend, pursue, or participate in legal actions or proceedings or
            exercise a legal right; to take precautions against actual or
            potential liabilities; to investigate or respond to potential or
            suspected illegal activities, fraud, or threats to the Site, its
            visitors, or the property or physical safety of any person; to
            enforce or investigate violations of our rules or terms of use; or
            as otherwise permitted or required by law.
          </p>
          <p>
            – With those that we so indicate at the time you provide the
            information.
          </p>
          <p>
            – To third parties when we have your consent or when we have
            parental consent if the visitor is a minor.
          </p>
          <p>– With any other third parties we may choose.</p>
          <p>
            We may store personal information in locations outside of our direct
            control; for instance, on servers or databases where the hosting
            provider is located. Additionally, we may share or sell aggregate
            information about our visitors that does not personally identify
            individuals with our partners, affiliates, advertisers, and other
            third parties without restriction. This information may include
            personal information that we have changed so that individuals are no
            longer personally identifiable. We may also share this information
            with third parties in order to analyze visitor data, activities, and
            usage of the Site or Services in order to make improvements to the
            Site, Services, and experiences of our visitors.
          </p>
          <p>
            If you choose to participate in any promotions or similar events
            through the Site or Services, the rules or terms and conditions for
            such events may change the way we share your information with third
            parties. Please review the applicable rules or terms and conditions
            for all such events in which you participate.
          </p>
          <p>
            3.<strong> **Links to Other Websites**</strong>
          </p>
          <p>
            This Site may contain links to or from other websites. This privacy
            policy only applies to information collected on this Site, and we
            are not responsible for other websites’ privacy practices. Please be
            aware of when you exit our Site using such links. We encourage you
            to review the privacy practices of all other websites you reach
            through links on our Site.
          </p>

          <p>
            4.<strong> Opt-Out Procedures</strong>
          </p>
          <p>
            As your privacy is important to us, we provide you with the
            following procedure(s) for opting out of future communications from
            us:
          </p>
          <p>
            <strong>Email.</strong> Send an email to thecryptohub.com@gmail.com
            explaining the specific communications or privacy practices you want
            to opt out of. You may also opt out by clicking “unsubscribe,” or a
            similar button, at the bottom of any emails we may send you and then
            following the online instructions. However, please note that it may
            not be possible to opt out of certain emails (for example,
            confirmation emails related to services you have requested).
          </p>
          <p>
            <strong>Cookies. </strong>
            In order to opt out of cookies and other tracking technologies, you
            can configure or disable cookies in your browser settings. However,
            please note that doing so may cause parts of the Site to function
            improperly.
          </p>

          <p>
            <strong>Third-Party Accounts. </strong>
            In the event that you have chosen to connect your account to another
            account you have on a third-party website, YOU ACKNOWLEDGE AND AGREE
            THAT PERSONAL INFORMATION MAY BE PROVIDED TO THE RELEVANT
            THIRD-PARTY WEBSITES HOSTING UNTIL SUCH TIME AS YOU DISCONNECT YOUR
            TWO ACCOUNTS. You acknowledge that such third-party websites are not
            subject to this privacy policy. Do not connect your accounts if you
            do not want personal information shared in this manner. You may
            disconnect your accounts by either 1) signing in, visiting your
            account page, and configuring the relevant settings, if available,
            or 2) emailing us at thecryptohub.com@gmail.com with your request.
          </p>

          <p>
            5. <strong>How to Access and Change Your Information</strong>
          </p>
          <p>
            You are responsible for keeping any personal information you provide
            on the Site current. Please email us at thecryptohub.com@gmail.com
            to request access to view, correct, or delete information you have
            provided to us. We will make reasonable efforts to comply with your
            requests, if possible. If you provided personal information in
            connection with a specific Service we provide, you may have to
            update or delete that information by returning to that Service page.
            Any requests to delete your information are subject to our internal
            reporting and retention policies as well as any legal obligations
            that we may have. You can also update or delete some or all of your
            personal information in your account by signing in, visiting your
            account page, and configuring the relevant settings.
          </p>

          <p>
            6. <strong>Notice of California Privacy Rights</strong>
          </p>
          <p>
            Pursuant to California Civil Code Section 1798.83, California
            residents who use our Site may request certain information regarding
            any disclosure of personal information to third parties for their
            direct marketing purposes. To make this request, please email us at
            thecryptohub.com@gmail.com or use the contact information provided
            below at the end of this policy. Should you choose to email us,
            please include in the subject line or body of your email the phrase
            “California Customer Choice Privacy Notice” and specify the personal
            information you do not wish to be shared with third parties for
            their direct marketing purposes. Please allow up to thirty (30) days
            for a response.
          </p>

          <p>
            7. <strong>Security</strong>
          </p>
          <p>
            We take the security of your information seriously and have
            electronic, physical, and administrative safeguards in place that
            comply with federal regulations for your protection. These security
            measures seek to protect your information both online and offline
            from disclosure, alteration, or unauthorized use. However, please
            keep in mind that no transmission of data over the internet is
            guaranteed to be completely secure. Third parties may be able to
            access private communications illegally; for instance, through the
            use of hacking and viruses. As such, all information you transmit on
            the Site or Services is at your own risk. We are not responsible for
            instances where third parties circumvent our security measures
            without authorization, illegally or otherwise.
          </p>
          <p>
            The information you submit to us is encrypted using Secure Sockets
            Layer (SSL) data encryption technology and is transmitted securely.
            You may verify this by locating “https” at the beginning of the
            address of the webpage or an icon of a closed lock in your browser.
            The computers and servers we use are also kept in a secure
            environment behind firewalls. We limit access to your information to
            those people that need to view it to perform necessary support
            tasks, including fulfilling your requests. We also require you to
            create a unique password to help secure your account. It is your
            responsibility to maintain the secrecy of your password and other
            login information. We will promptly notify you in the event that
            personal information becomes compromised according to our
            notification procedures outlined below or as otherwise required by
            applicable law.
          </p>
          <p>
            8. <strong>Children’s Privacy</strong>
          </p>
          <p>
            This Site does not knowingly collect personal information from
            persons under 18 years of age. If you are under 18 years of age, do
            not use this Site or provide any personal information to us. We will
            delete all information that we discover is provided by children
            under 18 years of age without verification of parental consent.
            Please email us at thecryptohub.com@gmail.com if you believe we have
            received personal information from a child aged under 18 and we will
            use our best efforts to remove such information.
          </p>
          <p>
            9. <strong>Changes to This Privacy Policy</strong>
          </p>
          <p>
            We may update this privacy policy at any time. We will post any
            changes in our privacy practices on this page with the date of the
            most recent revision indicated next to “Last updated” near the top
            of the page. If we make significant changes to the way we manage our
            visitors’ personal information, we will notify you by email or by
            posting prominent notice on our Site. It is your responsibility to
            ensure we have your current email address and to periodically check
            this page for any updates.
          </p>

          <p>
            10. <strong>Notification Procedures</strong>
          </p>
          <p>
            We reserve the right to determine the most appropriate means of
            providing you with any notice required or advisable, in our sole
            discretion, under the terms of this privacy policy or as required by
            law. We may choose to provide notification by email, physical
            written notice, posting prominently on the Site, or through other
            conspicuous means.
          </p>

          <p>
            11. <strong>Cross-Border Data Transfers</strong>
          </p>
          <p>
            Your personal information may be processed and transferred to
            countries other than your own, including, but not limited to, any
            country in which we operate. Some of these countries may have
            different laws and practices regarding data protection than your
            country. By using the Site, you agree to such cross-border transfers
            of your personal information.
          </p>
          <p>
            12.
            <strong>Contact Information</strong>
          </p>
          <p>
            Your feedback is important to us. To send us your questions,
            suggestions, or complaints, please contact us as follows:
          </p>
          <p>Phone: +442070961122</p>
          <p>Email: thecryptohub.com@gmail.com</p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyComp;
